
	import { Options } from 'flickity'
	import { defineComponent, Ref, ref } from 'vue'

	import Playmaker from '@/assets/image/Playmaker.png'
	import TailgaterPro from '@/assets/image/Tailgater-Pro.png'
	import Tailgater from '@/assets/image/Tailgater.png'
	import X2 from '@/assets/image/x2.png'
	import Flickity from '@/components/Flickity.vue'

	interface AntennaData {
		img: string,
		name: string,
		tagline: string,
		tvs: number,
		link: string,
	}

	export default defineComponent({
		components: {
			Flickity,
		},

		setup() {
			const flickity: Ref<typeof Flickity | null> = ref(null)

			const antennas: Array<AntennaData> = [
				{ img: Playmaker, name: 'DISH Playmaker®', tagline: 'Compact and lightweight', tvs: 1, link: 'https://www.dishformyrv.com/new-dish-playmaker-bundle-with-wally/' },
				{ img: TailgaterPro, name: 'DISH Tailgater®', tagline: 'Portable and mountable', tvs: 1, link: 'https://www.dishformyrv.com/dish-tailgater-satellite-antenna-bundle-with-wally/' },
				{ img: Tailgater, name: 'DISH Tailgater® Pro', tagline: '100% Nationwide coverage', tvs: 2, link: 'https://www.dishformyrv.com/dish-tailgater-pro-satellite-antenna-bundle-with-wally/' },
				{ img: X2, name: 'Pathway® X2', tagline: 'Best option for East Coast', tvs: 2, link: 'https://www.dishformyrv.com/winegard-pathway-x2-bundle-with-wally/' },
			]

			const flickityOptions: Options = {
				groupCells: true,
				pageDots: false,
				watchCSS: true,
			}

			function resizeAntennas(): void {
				flickity.value!.resize()
			}

			return {
				flickity,
				resizeAntennas,
				antennas,
				flickityOptions,
			}
		},
	})
